import { Injectable, inject } from '@angular/core';
import { CollectionHandle, Entry, Silo } from '@org-quicko/silo-client';
import { from, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface CountryReference {
    name: string;
    country_code: string | null;
    numeric_code: number;
    flag: string | null;
    flag_1x1: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class ReferenceDataService {
    private readonly countriesCollection: CollectionHandle<CountryReference> = inject(Silo)
        .scope('company-quicko', environment.silo_environment)
        .collection<CountryReference>('company-quicko-country');

    /**
     * Reads countries from the shared Company Quicko Silo project.
     * @returns Countries suitable for the phone-number selector.
     */
    getCountries(): Observable<Entry<CountryReference>[]> {
        return from(this.countriesCollection.all({ limit: 300 }).toArray().then((countries) => countries.filter((country) => country.country_code != null)));
    }

}
